(() => {
  if (typeof __webpack_require__ !== 'undefined') {
    var oldGetScript = __webpack_require__.u;
    var oldLoadScript = __webpack_require__.e;
    var queryMap = {};
    var countMap = {};
    var getRetryDelay = function () {
      return 0;
    };
    __webpack_require__.u = function (chunkId) {
      var result = oldGetScript(chunkId);
      return (
        result +
        (queryMap.hasOwnProperty(chunkId) ? '?' + queryMap[chunkId] : '')
      );
    };
    __webpack_require__.e = function (chunkId) {
      var result = oldLoadScript(chunkId);
      return result.catch(function (error) {
        var retries = countMap.hasOwnProperty(chunkId) ? countMap[chunkId] : 3;
        if (retries < 1) {
          var realSrc = oldGetScript(chunkId);
          error.message =
            'Loading chunk ' +
            chunkId +
            ' failed after 3 retries.\n(' +
            realSrc +
            ')';
          error.request = realSrc;
          window.handleScriptLoadError('Retry Chunk Load');
          throw error;
        }
        return new Promise(function (resolve) {
          var retryAttempt = 3 - retries + 1;
          setTimeout(function () {
            var retryAttemptString = '&retry-attempt=' + retryAttempt;
            var cacheBust = 'cache-bust=true' + retryAttemptString;
            queryMap[chunkId] = cacheBust;
            countMap[chunkId] = retries - 1;
            resolve(__webpack_require__.e(chunkId));
          }, getRetryDelay(retryAttempt));
        });
      });
    };
  }
})();
